import { render, staticRenderFns } from "./permissionAddOrUpdate.vue?vue&type=template&id=0370e741&scoped=true&"
import script from "./permissionAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./permissionAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370e741",
  null
  
)

export default component.exports